// index.js
const io = require('socket.io-client');
//imports
import { addMenuEventListeners, addFormEventListeners } from './events/menuEvents.js';
import { createConfetti } from './components/confetti.js';
import { showAchievement } from './components/xboxAchievement.js';
import { initializePlayerCardMenu, createFloatingEmoji, cleanupPlayerCardMenu, clearNudgeCooldowns, handleNudgeFailed, handleNudgeSuccess, syncNudgeCooldowns } from './components/playerCardMenu.js';
import { showToast, showKickVoteToast, updateKickVoteToast, removeToast } from './components/toast.js';

const socket = io.connect('https://pokerws.bikkies.xyz');

// Define the current room code as an empty string (global variable)
let globalCurrentRoomCode = '';
// Store the current player's session ID
let currentPlayerSessionId = null;
// Track if a disconnection modal is currently displayed
let isDisconnectionModalShown = false;
// Track if a kicked modal is currently displayed
let isKickedModalShown = false;
// Store current players state for nudge feature
let currentPlayers = [];

// Get the following HTML elements using their IDs
const topTitleArea = document.getElementById('top-title-area');
const roomCodeTop = document.getElementById('room-code-top');
const joiningRoomNameDiv = document.getElementById('enter-name-joining-room-name');
const playersDiv = document.getElementById('player-cards');
const spectatorsDiv = document.getElementById('spectator-cards');
const selectableCardsDiv = document.getElementById('cards');

// Get the play area and create-join area elements
const playArea = document.getElementById('play-area');
const createJoinArea = document.getElementById('create-join-area');
const playerNameFormArea = document.getElementById('player-name-area');

// Select the flip cards button element using its query selector
const flipCardsButton = document.querySelector('.flip-card-button');
// Select the reset button container and button
const resetButtonContainer = document.getElementById('reset-button-container');
const resetButton = document.getElementById('reset-cards-button');

// Select all card number elements on the page
const selectableCards = document.querySelectorAll('.card-number');

// Get the loader element using its ID
const loaderElement = document.getElementById('loader');

// Initialize the selected card variable as null
let selectedCard = null;

// Initialize the state variable to track if cards are flipped
let areCardsFlipped = false;


// This function handles the event when the client connects to the server
socket.on('connect', () => {
    // Log that the client has connected to the server
    console.log('Connected to server');

    // Get whether there is a room ID in the URL to join
    const urlParams = new URLSearchParams(window.location.search);
    const roomId = urlParams.get('room');

    // If there is a room ID, emit a check to see if the room exists on the server
    if (roomId) {
        socket.emit('checkRoomExists', roomId);
    }
    else {
        // Display the create and join area if no room ID is present
        displayCreateJoinArea();
    }
});

// This function handles the event when the server responds with information about the room's existence
socket.on('roomExists', (roomId) => {
    if (roomId) {
        // Join the specified room using the autoJoinRoom function
        autoJoinRoom(roomId);
    }
});

// This function handles the event when the server responds that the room does not exist
socket.on('roomDoesntExist', () => {
    // Display the create and join area if the room does not exist
    displayCreateJoinArea();
});

// This function handles the event when the client disconnects from the server
socket.on('disconnect', () => {
    // Log that the client has disconnected from the server
    console.log('Disconnected from server');

    // Check if player is currently in a room (play area is visible)
    if (!playArea.classList.contains('hidden')) {
        // Player was in a room when disconnected
        showDisconnectionModal();
    }
});

// This function is called when the window loads and performs several tasks.
// It pre-fills the create room form with previously stored data from local storage, if available.
// The function gets the elements for player name and room name in the create form using their IDs.
// If a player name is stored in local storage, it sets the value of the player name field in the create form.
// Similarly, if a room name is stored in local storage, it sets the value of the room name field in the create form.
// Additionally, the function also pre-fills the player name field in the join form with any previously stored data from local storage, if available.
window.onload = function() {
    // pre-fill the create room form
    const playerNameCreate = document.getElementById('player-name-create');
    const roomNameCreate = document.getElementById('room-name-create');
    const storedName = localStorage.getItem('playerName');
    if (storedName) {
        playerNameCreate.value = storedName;
    }
    const storedRoomName = localStorage.getItem('roomName');
    if (storedRoomName) {
        roomNameCreate.value = storedRoomName;
    }

    // pre-fill the join room form
    const playerNameJoin = document.getElementById('player-name-join');
    if (storedName) {
        playerNameJoin.value = storedName;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Check for saved theme preference, default to dark
    const savedTheme = localStorage.getItem('theme') || 'dark';
    const body = document.body;
    const darkModeToggleIcon = document.querySelector('#dark-mode-toggle i');

    if (savedTheme === 'dark') {
        body.classList.add('dark-theme');
        if (darkModeToggleIcon) {
            darkModeToggleIcon.classList.remove('fa-moon-o');
            darkModeToggleIcon.classList.add('fa-sun-o');
        }
    } else {
        body.classList.remove('dark-theme');
        if (darkModeToggleIcon) {
            darkModeToggleIcon.classList.remove('fa-sun-o');
            darkModeToggleIcon.classList.add('fa-moon-o');
        }
    }
});

// Listen for the event 'roomCreated' on the socket
socket.on('roomCreated', (code) => {
    // Update the room code using the provided code from the event
    updateRoomCode(code);
});

// This function handles the event when a player joins a room and updates various elements on the page.
socket.on('roomJoinedToPlayer', ({ roomId, newRoomName, playersJson, playerJson, roomCardsFlipped, cardSet, sessionId }) => {
    // Log a message to the console indicating that the player is joining a room.
    console.log("Joining room as player...");

    // Parse the player JSON object to extract information about the player.
    const player = JSON.parse(playerJson);

    // Store the session ID received from server
    if (sessionId) {
        setSessionId(roomId, sessionId);
        currentPlayerSessionId = sessionId; // Store globally for comparisons
    }

    // Update the room name to reflect the new room name provided.
    updateRoomName(newRoomName);

    // Update the room code to match the room ID provided.
    updateRoomCode(roomId);

    // Hide the form area and display the play area on the page.
    hideFormAreaAndDisplayPlayArea();

    // Update the player cards with fresh data from the playersJSON provided.
    updatePlayerCardsFresh(playersJson);

    // Change the role of the player based on the value of the isPlayer property.
    playerChangeRole(player.isPlayer);

    // Store the state of cardsFlipped
    areCardsFlipped = roomCardsFlipped;
    // Render the cards dynamically based on the cardSet
    renderSelectableCards(cardSet, areCardsFlipped);



    // Add the room code to the URL as a query parameter.
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('room', roomId);
    const newUrl = window.location.pathname + '?' + urlParams.toString();
    window.history.pushState(null, null, newUrl);

    // Convert the isPlayer property to a string and store it in a variable.
    const isPlayerString = player.isPlayer.toString();
    // Set a cookie for the roomID that expires in 7 days with the value of the isPlayer property converted to a string.
    setCookie(`${roomId}-isPlayer`, isPlayerString, 7);

    // Set the player name in local storage.
    localStorage.setItem('playerName', player.name);

    // Initialize player card menu system
    initializePlayerCardMenu(socket, () => currentPlayerSessionId, () => ({ cardsFlipped: areCardsFlipped, players: currentPlayers }));

    if (roomCardsFlipped){
        socket.emit('playerJoinedWithFlippedCards', roomId);
    }
});

// This function is sent from the server to the client when the client exits a room.
// It updates the room code and logs a message to the console.
// The function removes the 'isPlayer' cookie associated with the room id.
// It also changes the URL of the page using the history API and shows the form area while hiding the play area.
socket.on('roomExitedToPlayer', (roomId) => {
    updateRoomCode('');
    console.log("Leaving room as player..." + roomId);
    const newUrl = window.location.pathname;
    removeCookie(`${roomId}-isPlayer`);
    window.history.pushState(null, null, newUrl);
    showFormAreaAndHidePlayArea();
});

//TODO - these functions can have common code combined and be made shorter
socket.on('playerTypeSwitchedToPlayer', ({playerJson, roomId}) => {
    const player = JSON.parse(playerJson);
    const playerId = player.id;
    let newPlayerType = player.isPlayer;
    // Convert the isPlayer property to a string and store it in a variable.
    const isPlayerString = newPlayerType.toString();
    // Set a cookie for the roomID that expires in 7 days with the value of the isPlayer property converted to a string.
    setCookie(`${roomId}-isPlayer`, isPlayerString, 7);
    //Remove both cards to be safe and add the new card
    const playerCard = document.getElementById(`player-${playerId}`);
    if (playerCard){
        playerCard.parentNode.removeChild(playerCard);
    }

    const spectatorCard = document.getElementById(`spectator-${playerId}`);
    if (spectatorCard){
        spectatorCard.parentNode.removeChild(spectatorCard);
    }
    if (newPlayerType){
        const card = createPlayerCardFlipBox(player);
        playersDiv.appendChild(card);
        console.log("You switched your player type to Player");
    }
    else{
        const card = createSpectatorCard(player);
        spectatorsDiv.appendChild(card);
        console.log("You switched your player type to Spectator");
    }

    // Change the role of the player based on the value of the isPlayer property.
    playerChangeRole(player.isPlayer);
});

socket.on('playerSwitchedRole', ({ playerJson }) => {
    const player = JSON.parse(playerJson);
    let newPlayerType = player.isPlayer;
    let playerId = player.id;
    //Remove both cards to be safe and add the new card
    const playerCard = document.getElementById(`player-${playerId}`);
    if (playerCard){
        playerCard.parentNode.removeChild(playerCard);
    }

    const spectatorCard = document.getElementById(`spectator-${playerId}`);
    if (spectatorCard){
        spectatorCard.parentNode.removeChild(spectatorCard);
    }
    if (newPlayerType){
        const card = createPlayerCardFlipBox(player);
        playersDiv.appendChild(card);
        console.log("Player " + playerId + " switched roles to Player");
    }
    else{
        const card = createSpectatorCard(player);
        spectatorsDiv.appendChild(card);
        console.log("Player " + playerId + " switched roles to Spectator");
    }
});


socket.on('playerJoined', (playerJson) => {
    const player = JSON.parse(playerJson);
    console.log("Single player joined");
    //console.log(player);
    //console.log(player.isPlayer);
    if (player.isPlayer) {
        const card = createPlayerCardFlipBox(player);
        playersDiv.appendChild(card);
    }
    else {
        const card = createSpectatorCard(player);
        spectatorsDiv.appendChild(card);
    }
});
socket.on('playerLeft', (playerId) => {
    const playerCard = document.getElementById(`player-${playerId}`);
    if (playerCard){
        playerCard.parentNode.removeChild(playerCard);
    }

    const spectatorCard = document.getElementById(`spectator-${playerId}`);
    if (spectatorCard){
        spectatorCard.parentNode.removeChild(spectatorCard);
    }
});

// Handle player disconnecting (grace period started)
socket.on('playerDisconnecting', ({ playerId, gracePeriodMs }) => {
    const playerCard = document.getElementById(`player-${playerId}`);
    if (playerCard) {
        showLostConnectionIndicator(playerCard);
    }

    const spectatorCard = document.getElementById(`spectator-${playerId}`);
    if (spectatorCard) {
        showLostConnectionIndicator(spectatorCard);
    }
});

// Handle player reconnected
socket.on('playerReconnected', ({ playerId }) => {
    const playerCard = document.getElementById(`player-${playerId}`);
    if (playerCard) {
        removeLostConnectionIndicator(playerCard);
    }

    const spectatorCard = document.getElementById(`spectator-${playerId}`);
    if (spectatorCard) {
        removeLostConnectionIndicator(spectatorCard);
    }
});

socket.on('playerStatusChanged', ({ playerId, isPlayer }) => {
    console.log(`Player ${playerId} status changed to ${isPlayer ? 'player' : 'spectator'}`);

    // Update cookie if this is the current player
    if (playerId === currentPlayerSessionId) {
        const roomId = globalCurrentRoomCode;
        const isPlayerString = isPlayer.toString();
        setCookie(`${roomId}-isPlayer`, isPlayerString, 7);

        // Update the role UI
        playerChangeRole(isPlayer);
    }

    // The playersUpdate event will handle moving the card to the correct section
});

function hideFormAreaAndDisplayPlayArea()
{
    playArea.classList.remove('hidden');
    topTitleArea.classList.add('hidden');
    createJoinArea.classList.add('hidden');
    playerNameFormArea.classList.add('hidden');
}

function showFormAreaAndHidePlayArea()
{
    playArea.classList.add('hidden');
    topTitleArea.classList.remove('hidden');
    createJoinArea.classList.remove('hidden');
    playerNameFormArea.classList.add('hidden');
}

function displayCreateJoinArea() {
    loaderElement.classList.add('hidden');
    topTitleArea.classList.remove('hidden');
    createJoinArea.classList.remove('hidden');
    playerNameFormArea.classList.add('hidden');
}

function displayEnterNameForm(roomId, name = null)
{
    if (name) {
        document.getElementById('join-pre-filled-player-name-join').value = name;
    }
    socket.emit('displayedEnterNameForm', roomId);
    playArea.classList.add('hidden');
    topTitleArea.classList.add('hidden');
    createJoinArea.classList.add('hidden');
    playerNameFormArea.classList.remove('hidden');
}

socket.on('sendRoomNameForJoiningRoomForm', (roomName) => {
    joiningRoomNameDiv.textContent = `${roomName}`;
});

function updateRoomCode(code)
{
    globalCurrentRoomCode = code;
    roomCodeTop.textContent = `Room code: ${code}`;
}

function updateRoomName(newRoomName)
{
    console.log("Room name updated");
    console.log(newRoomName);
    const roomNameDiv = document.getElementById('room-name-title');
    roomNameDiv.textContent = `${newRoomName}`;
}




socket.on('cardsFlipped', ({ playersJson, average, median, achievementText }) => {
    console.log("Cards flipped");
    console.log("Average score: " + average);
    updatePlayerCardScores(playersJson);
    updateFlipCardsButton(true);
    updateAverageScoreCard(average);
    updateMedianScoreCard(median);
    areCardsFlipped = true; // Update the state
    // Remove event listeners to disable interaction
    const selectableCards = document.querySelectorAll('.card-number');
    selectableCards.forEach(card => {
        card.removeEventListener('click', cardClickHandler);
    });

    // Check if achievement should be shown (all votes match)
    if (achievementText) {
        console.log("Triggering achievement: " + achievementText);
        // Small delay to let cards flip first
        setTimeout(() => {
            createConfetti();
            showAchievement(achievementText, 100);
        }, 500);
    }
});

function updateAverageScoreCard(average) {
    const avgScoreCard = document.getElementById('avg-score-card');
    const avgScoreElement = avgScoreCard.querySelector('.score');
    avgScoreElement.textContent = average.toString();
}

function updateMedianScoreCard(median) {
    const avgScoreCard = document.getElementById('median-score-card');
    const avgScoreElement = avgScoreCard.querySelector('.score');
    avgScoreElement.textContent = median.toString();
}

socket.on('gameReset', () => {
    resetPlayerScores();
    clearNudgeCooldowns();
});

function updatePlayerCardScores(playersJson) {
    const players = JSON.parse(playersJson);

    players.forEach(player => {
        console.log("Updating score for " + player.name + " to " + player.score);
        const card = document.getElementById(`player-${player.id}`);
        if (card) {
            const scoreDiv = card.querySelector('.score');
            // Clear previous content
            scoreDiv.innerHTML = '';

            if (player.score === 'pepsi') {
                const img = document.createElement('img');
                img.src = '/images/pepsi.svg';
                img.alt = 'Pepsi';
                img.className = 'player-card-image'; // Add a class for styling
                scoreDiv.appendChild(img);
            } else {
                scoreDiv.textContent = player.score;
            }

            const flipBoxElement = card.querySelector('.flip-box');
            flipBoxElement.classList.add('flipped');
        }
    });
}

function resetPlayerScores() {
    const playerCards = document.querySelectorAll('.box-item');
    playerCards.forEach(card => {
        card.classList.remove('selected');
        const scoreElement = card.querySelector('.score');
        const flipBoxElement = card.querySelector('.flip-box');
        flipBoxElement.classList.remove('flipped');
        // Clear previous content
        scoreElement.innerHTML = '';

        const blankScore = document.createElement('div');
        blankScore.className = 'blankscore';
        blankScore.textContent = '?';
        scoreElement.appendChild(blankScore);
    });
}

function updatePlayerCardsFresh(playersJson) {
    const players = JSON.parse(playersJson);
    currentPlayers = players; // Store current players for nudge feature
    playersDiv.innerHTML = '';
    spectatorsDiv.innerHTML = '';

    players.forEach(player => {

        if (player.isPlayer) {
            //console.log("Creating player card for " + player.name + " with score " + player.score + "");
            const card = createPlayerCardFlipBox(player);
            if (player.cardSelected) {
                card.classList.add('selected');
            }
            playersDiv.appendChild(card);
        }
        else {
            const card = createSpectatorCard(player);
            spectatorsDiv.appendChild(card);
        }
    });

    // Re-initialize player card menu system after cards are updated
    initializePlayerCardMenu(socket, () => currentPlayerSessionId, () => ({ cardsFlipped: areCardsFlipped, players: currentPlayers }));
}

function createPlayerCard(player) {
    const card = document.createElement('div');
    card.id = `player-${player.id}`;
    card.className = 'card';

    const name = document.createElement('div');
    name.className = 'name';
    name.textContent = player.name;

    const score = document.createElement('div');
    score.className = 'score';
    score.textContent = player.score;

    card.appendChild(name);
    card.appendChild(score);

    return card;
}

function createPlayerCardFlipBox(player) {

    const boxItem = document.createElement('div');
    boxItem.id = `player-${player.id}`;
    boxItem.className = 'box-item';

    const card = document.createElement('div');
    card.className = 'flip-box';

    const flipBoxFront = document.createElement('div');
    flipBoxFront.className = 'flip-box-front';
    //flipBoxFront.style.backgroundImage = `url('https://s25.postimg.cc/frbd9towf/cta-2.png')`;

    const flipBoxBack = document.createElement('div');
    flipBoxBack.className = 'flip-box-back';
    //flipBoxBack.style.backgroundImage = `url('https://s25.postimg.cc/frbd9towf/cta-1.png')`;

    const frontInner = document.createElement('div');
    frontInner.className = 'inner';

    const backInner = document.createElement('div');
    backInner.className = 'inner';

    const name = document.createElement('div');
    name.className = 'name';
    name.textContent = player.name;

    const name2 = document.createElement('div');
    name2.className = 'name';
    name2.textContent = player.name;

    const score = document.createElement('div');
    score.className = 'score';

    if (player.score === 'pepsi') {
        const img = document.createElement('img');
        img.src = '/images/pepsi.svg';
        img.alt = 'Pepsi';
        img.className = 'player-card-image'; // Add a class for styling
        score.appendChild(img);
    } else {
        score.textContent = player.score;
    }

    const blankscore = document.createElement('div');
    blankscore.className ='blankscore';
    blankscore.textContent = '?';

    frontInner.appendChild(name2);
    frontInner.appendChild(blankscore);
    flipBoxFront.appendChild(frontInner);

    backInner.appendChild(name);
    backInner.appendChild(score);
    flipBoxBack.appendChild(backInner);

    card.appendChild(flipBoxFront);
    card.appendChild(flipBoxBack);

    boxItem.appendChild(card);

    return boxItem;
}

function createSpectatorCard(player) {
    const card = document.createElement('div');
    card.id = `spectator-${player.id}`;
    card.className = 'spectator-card';

    const name = document.createElement('div');
    name.className = 'name';
    name.textContent = player.name;
    card.appendChild(name);
    return card;
}

function showLostConnectionIndicator(card) {
    // Don't add if already present
    if (card.querySelector('.lost-connection-indicator')) {
        return;
    }

    const indicator = document.createElement('div');
    indicator.className = 'lost-connection-indicator';

    const spinner = document.createElement('div');
    spinner.className = 'connection-spinner';

    const text = document.createElement('div');
    text.className = 'connection-text';
    text.textContent = 'Lost Connection';

    indicator.appendChild(spinner);
    indicator.appendChild(text);
    card.appendChild(indicator);

    // Add dimmed class to card
    card.classList.add('disconnected');
}

function removeLostConnectionIndicator(card) {
    const indicator = card.querySelector('.lost-connection-indicator');
    if (indicator) {
        indicator.remove();
    }
    card.classList.remove('disconnected');
}

socket.on('playersUpdate', (playersJson) => {
    updatePlayerCardsFresh(playersJson);
});


function playerChangeRole(isPlayer) {
    if (isPlayer) {
        selectableCardsDiv.classList.remove('hidden');
        // If the cards are not flipped, add event listeners
        if (!areCardsFlipped) {
            const selectableCards = document.querySelectorAll('.card-number');
            selectableCards.forEach(card => {
                card.addEventListener('click', cardClickHandler);
            });
        }
    } else {
        selectableCardsDiv.classList.add('hidden');
        // Remove event listeners
        const selectableCards = document.querySelectorAll('.card-number');
        selectableCards.forEach(card => {
            card.removeEventListener('click', cardClickHandler);
        });
    }
}


function updatePlayerScore(playerId, score) {
    const scoreEl = document.getElementById(`player-${playerId}`).querySelector('.score');
    scoreEl.textContent = score;
}




// Call the function to add event listeners
// For the hamburger menu
addMenuEventListeners(socket);
// For the forms
addFormEventListeners(socket);

socket.on('roomNotFound', () => {
    console.log('Room not found');
});


// Re-add event listeners to the newly rendered cards
selectableCards.forEach(card => {
    card.addEventListener('click', cardClickHandler);
});

function cardClickHandler(event) {
    let card = event.target;

    // If the clicked element is the image, get the parent card-number div
    if (card.tagName.toLowerCase() === 'img' && card.classList.contains('card-image')) {
        card = card.parentElement;
    }

    const value = card.dataset.value;

    // Rest of the function remains the same...
    // Remove highlight from previously selected card
    if (selectedCard) {
        if (selectedCard == card) {
            selectedCard.classList.remove('selected');
            selectedCard = null;
            socket.emit('card-deselected', {cardNumber: value});
        } else {
            selectedCard.classList.remove('selected');
            // Select new card
            socket.emit('card-selected', {cardNumber: value});
            selectedCard = card;
            selectedCard.classList.add('selected');
        }
    } else {
        // Select new card
        socket.emit('card-selected', {cardNumber: value});
        selectedCard = card;
        selectedCard.classList.add('selected');
    }
}

socket.on('scoreUpdated', (data) => {
    const playerId = data.playerId;
    console.log(`Player ${data.playerId} selected a card`);

    // Update player card to show selected state
    const card = document.getElementById(`player-${playerId}`);
    if (card) {
        card.classList.add('selected');
    }
});

// Handle card selection sync across own tabs (only sent to this player)
socket.on('playerCardSelected', (data) => {
    const playerId = data.playerId;
    const cardNumber = data.cardNumber;
    console.log(`Syncing own card selection to ${cardNumber} across tabs`);

    // Sync the selected card at the bottom across all own tabs
    if (playerId === currentPlayerSessionId && cardNumber) {
        // Clear previous selection
        if (selectedCard) {
            selectedCard.classList.remove('selected');
        }

        // Find and select the new card
        const selectableCards = document.querySelectorAll('.card-number');
        selectableCards.forEach(selectableCard => {
            if (selectableCard.dataset.value === cardNumber) {
                selectableCard.classList.add('selected');
                selectedCard = selectableCard;
            }
        });
    }
});

socket.on('playerDeselectedCard', (data) => {
    const playerId = data.playerId;
    console.log(`Player ${data.playerId} deselected their card`);

    // Update player card to show deselected state
    const card = document.getElementById(`player-${playerId}`);
    if (card) {
        card.classList.remove('selected');
    }

    // If this is the current player, clear the selected card at the bottom
    if (playerId === currentPlayerSessionId) {
        if (selectedCard) {
            selectedCard.classList.remove('selected');
            selectedCard = null;
        }
    }
});

socket.on('cardsReset', () => {
    console.log(`Reset received from server`);
    resetPlayerScores();
    updateAverageScoreCard('?');
    updateMedianScoreCard('?');
    updateFlipCardsButton(false);
    clearSelection();
    clearNudgeCooldowns();
    areCardsFlipped = false; // Update the state
    // Re-add event listeners to the newly rendered cards
    const selectableCards = document.querySelectorAll('.card-number');
    selectableCards.forEach(card => {
        card.addEventListener('click', cardClickHandler);
    });
});

flipCardsButton.addEventListener('click', () => {
    console.log("Sending flip for room code: " + globalCurrentRoomCode);
    socket.emit('flipCards');
});

function updateFlipCardsButton(isFlipped) {
    const flipCardsButton = document.querySelector('#flip-cards-button .flip-card-button');
    if (isFlipped) {
        flipCardsButton.classList.add('hidden');
        resetButtonContainer.classList.remove('hidden'); // Show reset button container
    } else {
        flipCardsButton.classList.remove('hidden');
        resetButtonContainer.classList.add('hidden'); // Hide reset button container
    }
}

resetButton.addEventListener('click', () => {
    console.log("Resetting cards for room code: " + globalCurrentRoomCode);
    socket.emit('flipCards'); // TODO: Just sending flip again, but should have a separate reset
});

function clearSelection() {
    if (selectedCard) {
        selectedCard.classList.remove('selected');
        selectedCard = null;
    }
}

function autoJoinRoom(roomId) {
    //Hide loader
    loaderElement.classList.add('hidden');
    // Get the player name from local storage
    const playerName = localStorage.getItem('playerName');
    const isPlayer = getCookie(`${roomId}-isPlayer`);
    const sessionId = getSessionId(roomId);
    console.log(`Auto-joining room ${roomId} as ${playerName}`);
    console.log("Is player: " + isPlayer);
    console.log("Session ID: " + sessionId);
    if (roomId) {
        if (playerName && isPlayer === 'true') {
            socket.emit('joinRoom', { roomId, playerName, isPlayer: true, sessionId });
        }
        else if (playerName && isPlayer === 'false'){
            socket.emit('joinRoom', { roomId, playerName, isPlayer: false, sessionId });
        }
        else if (playerName){
            //Display enter name form
            console.log("There's a stored name but new to this room - show form to enter name and join");
            displayEnterNameForm(roomId, playerName);
        }
        else{
            //Display enter name form
            console.log("No player name - show form to enter name");
            displayEnterNameForm(roomId);
        }
    }
}

// Session ID management functions
function getSessionId(roomId) {
    const storageKey = `${roomId}-sessionId`;
    return localStorage.getItem(storageKey);
}

function setSessionId(roomId, sessionId) {
    const storageKey = `${roomId}-sessionId`;
    localStorage.setItem(storageKey, sessionId);
    console.log(`Stored session ID for room ${roomId}: ${sessionId}`);
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function removeCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

function getCardSetValues(cardSet) {
    if (cardSet === 'regular') {
        return ['0', '0.5', '1', '2', '3', '5', '8', '13', '20', '40', '100', '?', 'pepsi']; // Changed '☕' to 'pepsi'
    } else if (cardSet === 'goofy') {
        return ['0', '0.5', '1', '2', '3', '4', '7', '9', '12', '21', '42', '106', '?', 'pepsi']; // Changed '☕' to 'pepsi'
    } else {
        // Default to regular if cardSet is not recognized
        return ['0', '0.5', '1', '2', '3', '5', '8', '13', '20', '40', '100', '?', 'pepsi']; // Changed '☕' to 'pepsi'
    }
}

function renderSelectableCards(cardSet, areCardsFlipped) {
    const cardValues = getCardSetValues(cardSet);
    const cardsContainer = document.getElementById('cards');
    cardsContainer.innerHTML = ''; // Clear any existing cards

    cardValues.forEach(value => {
        const cardDiv = document.createElement('div');
        cardDiv.className = 'card-number';
        cardDiv.dataset.value = value;

        // Check if the value is 'pepsi' to render the SVG
        if (value === 'pepsi') {
            const img = document.createElement('img');
            img.src = '/images/pepsi.svg';
            img.alt = 'Pepsi';
            img.className = 'card-image'; // Add a class for styling
            cardDiv.appendChild(img);
        } else {
            cardDiv.textContent = value;
        }

        cardsContainer.appendChild(cardDiv);
    });

    // After rendering the cards, add event listeners if cards are not flipped
    if (!areCardsFlipped) {
        const selectableCards = document.querySelectorAll('.card-number');
        selectableCards.forEach(card => {
            card.addEventListener('click', cardClickHandler);
        });
    }
}


export function toggleDarkMode() {
    const body = document.body;
    body.classList.toggle('dark-theme');

    // Update the icon
    const darkModeToggleIcon = document.querySelector('#dark-mode-toggle i');
    if (body.classList.contains('dark-theme')) {
        darkModeToggleIcon.classList.remove('fa-moon-o');
        darkModeToggleIcon.classList.add('fa-sun-o');
        // Save preference
        localStorage.setItem('theme', 'dark');
    } else {
        darkModeToggleIcon.classList.remove('fa-sun-o');
        darkModeToggleIcon.classList.add('fa-moon-o');
        // Save preference
        localStorage.setItem('theme', 'light');
    }
}

// Export getSessionId and getter for currentPlayerSessionId
export function getCurrentPlayerSessionId() {
    return currentPlayerSessionId;
}
export { getSessionId };

// Socket.io listeners for player card menu features

// Handle incoming emoji reactions
socket.on('playerReactionBroadcast', ({ targetPlayerId, emoji }) => {
    const playerCard = document.getElementById(`player-${targetPlayerId}`);
    if (playerCard) {
        createFloatingEmoji(emoji, playerCard);
    }
});

// Handle incoming nudge (successful nudge from server)
socket.on('playerNudged', ({ targetPlayerId, nudgerSessionId }) => {
    // Record cooldown if we're the nudger
    handleNudgeSuccess({ targetPlayerId, nudgerSessionId }, currentPlayerSessionId);

    const playerCard = document.getElementById(`player-${targetPlayerId}`);
    if (playerCard) {
        // Add shake animation for everyone
        playerCard.classList.add('shaking');
        setTimeout(() => {
            playerCard.classList.remove('shaking');
        }, 500);
    }

    // Play nudge sound ONLY for the nudger or the person being nudged
    if (nudgerSessionId === currentPlayerSessionId || targetPlayerId === currentPlayerSessionId) {
        const nudgeSound = new Audio('/audio/nudge.mp3');
        nudgeSound.play().catch(err => {
            console.log('Could not play nudge sound:', err);
        });
    }
});

// Handle nudge failure (e.g., cooldown active)
socket.on('nudgeFailed', ({ targetPlayerId, remainingMs, reason }) => {
    console.log(`Nudge failed: ${reason}, ${Math.ceil(remainingMs / 1000)}s remaining`);

    // Record the cooldown based on server's response
    handleNudgeFailed({ targetPlayerId, remainingMs });
});

// Sync nudge cooldowns from server (on join/refresh)
socket.on('nudgeCooldownsSync', ({ cooldowns }) => {
    syncNudgeCooldowns({ cooldowns });
});

// Handle kick vote initiated
socket.on('kickVoteStarted', ({ targetPlayerId, targetPlayerName, duration, currentVotes, requiredVotes, initiatorSessionId }) => {
    const isInitiator = initiatorSessionId === currentPlayerSessionId; // Compare session IDs
    const isTarget = targetPlayerId === currentPlayerSessionId; // Compare session IDs

    console.log('Kick vote started - Target/Initiator check:', {
        targetPlayerId,
        initiatorSessionId,
        currentPlayerSessionId,
        isTarget,
        isInitiator
    });

    const toastId = showKickVoteToast({
        playerName: targetPlayerName,
        duration: duration,
        targetPlayerId: targetPlayerId,
        currentVotes: currentVotes,
        requiredVotes: requiredVotes,
        isInitiator: isInitiator,
        isTarget: isTarget,
        onVote: (targetId, voteYes) => {
            // Send Yes/No vote to server
            socket.emit('voteKick', {
                targetPlayerId: targetId,
                voteYes: voteYes
            });
        }
    });
});

// Handle kick vote updated (new vote received)
socket.on('kickVoteUpdated', ({ targetPlayerId, currentVotes, requiredVotes }) => {
    const toastId = `kick-vote-${targetPlayerId}`;
    updateKickVoteToast(toastId, currentVotes, requiredVotes);
});

// Handle kick vote passed
socket.on('kickVotePassed', ({ targetPlayerId, targetPlayerName }) => {
    // Remove countdown toast
    const toastId = `kick-vote-${targetPlayerId}`;
    removeToast(toastId);

    // Show success toast
    showToast({
        title: 'Kick Vote Passed',
        message: `${targetPlayerName} has been kicked from the room.`,
        type: 'success',
        duration: 5000
    });
});

// Handle kick vote failed
socket.on('kickVoteFailed', ({ targetPlayerId, targetPlayerName }) => {
    // Remove countdown toast
    const toastId = `kick-vote-${targetPlayerId}`;
    removeToast(toastId);

    // Show failed toast
    showToast({
        title: 'Kick Vote Failed',
        message: `The vote to kick ${targetPlayerName} did not pass.`,
        type: 'failed',
        duration: 5000
    });
});

// Handle being kicked
socket.on('youWereKicked', () => {
    // Clean up local state
    updateRoomCode('');
    const newUrl = window.location.pathname;
    window.history.pushState(null, null, newUrl);

    // Hide play area and show kicked message
    showFormAreaAndHidePlayArea();

    // Show kicked message overlay
    showKickedMessage();
});

function showKickedMessage() {
    // Prevent multiple modals from stacking
    if (isKickedModalShown) {
        return;
    }
    isKickedModalShown = true;

    // Create overlay
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '20000';
    overlay.style.animation = 'fadeIn 0.3s ease-in';

    // Create message box
    const messageBox = document.createElement('div');
    messageBox.style.backgroundColor = 'var(--card-background-color)';
    messageBox.style.padding = '40px';
    messageBox.style.borderRadius = '20px';
    messageBox.style.textAlign = 'center';
    messageBox.style.maxWidth = '400px';
    messageBox.style.boxShadow = '0 10px 40px rgba(0, 0, 0, 0.3)';
    messageBox.style.animation = 'scaleIn 0.3s ease-out';

    // Title
    const title = document.createElement('h2');
    title.textContent = 'You Were Kicked';
    title.style.color = '#dc3545';
    title.style.marginBottom = '20px';
    title.style.fontSize = '28px';
    messageBox.appendChild(title);

    // Message
    const message = document.createElement('p');
    message.textContent = 'You have been removed from the room by a vote.';
    message.style.color = 'var(--text-color)';
    message.style.marginBottom = '30px';
    message.style.fontSize = '16px';
    messageBox.appendChild(message);

    // OK button
    const okButton = document.createElement('button');
    okButton.textContent = 'OK';
    okButton.style.padding = '12px 30px';
    okButton.style.backgroundColor = 'var(--button-background-color)';
    okButton.style.color = 'white';
    okButton.style.border = 'none';
    okButton.style.borderRadius = '8px';
    okButton.style.fontSize = '16px';
    okButton.style.fontWeight = 'bold';
    okButton.style.cursor = 'pointer';
    okButton.style.transition = 'all 0.2s ease';

    okButton.onmouseover = () => {
        okButton.style.backgroundColor = 'var(--button-background-hover-color)';
        okButton.style.transform = 'scale(1.05)';
    };

    okButton.onmouseout = () => {
        okButton.style.backgroundColor = 'var(--button-background-color)';
        okButton.style.transform = 'scale(1)';
    };

    okButton.onclick = () => {
        document.body.removeChild(overlay);
        isKickedModalShown = false; // Reset flag so modal can be shown again
    };

    messageBox.appendChild(okButton);
    overlay.appendChild(messageBox);
    document.body.appendChild(overlay);

    // Add animations
    const style = document.createElement('style');
    style.textContent = `
        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
        @keyframes scaleIn {
            from {
                transform: scale(0.7);
                opacity: 0;
            }
            to {
                transform: scale(1);
                opacity: 1;
            }
        }
    `;
    document.head.appendChild(style);
}

function showDisconnectionModal() {
    // Prevent multiple modals from stacking
    if (isDisconnectionModalShown) {
        return;
    }
    isDisconnectionModalShown = true;

    // Create overlay
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '20000';
    overlay.style.animation = 'fadeIn 0.3s ease-in';

    // Create message box
    const messageBox = document.createElement('div');
    messageBox.style.backgroundColor = 'var(--card-background-color)';
    messageBox.style.padding = '40px';
    messageBox.style.borderRadius = '20px';
    messageBox.style.textAlign = 'center';
    messageBox.style.maxWidth = '400px';
    messageBox.style.boxShadow = '0 10px 40px rgba(0, 0, 0, 0.3)';
    messageBox.style.animation = 'scaleIn 0.3s ease-out';

    // Title
    const title = document.createElement('h2');
    title.textContent = 'Connection Lost';
    title.style.color = '#dc3545';
    title.style.marginBottom = '20px';
    title.style.fontSize = '28px';
    messageBox.appendChild(title);

    // Message
    const message = document.createElement('p');
    message.textContent = 'The connection to the server was lost. You have been disconnected from the room.';
    message.style.color = 'var(--text-color)';
    message.style.marginBottom = '30px';
    message.style.fontSize = '16px';
    messageBox.appendChild(message);

    // OK button
    const okButton = document.createElement('button');
    okButton.textContent = 'OK';
    okButton.style.padding = '12px 30px';
    okButton.style.backgroundColor = 'var(--button-background-color)';
    okButton.style.color = 'white';
    okButton.style.border = 'none';
    okButton.style.borderRadius = '8px';
    okButton.style.fontSize = '16px';
    okButton.style.fontWeight = 'bold';
    okButton.style.cursor = 'pointer';
    okButton.style.transition = 'all 0.2s ease';

    okButton.onmouseover = () => {
        okButton.style.backgroundColor = 'var(--button-background-hover-color)';
        okButton.style.transform = 'scale(1.05)';
    };

    okButton.onmouseout = () => {
        okButton.style.backgroundColor = 'var(--button-background-color)';
        okButton.style.transform = 'scale(1)';
    };

    okButton.onclick = () => {
        document.body.removeChild(overlay);
        isDisconnectionModalShown = false; // Reset flag so modal can be shown again
        // Clear room state and return to main screen
        updateRoomCode('');
        currentPlayerSessionId = null;
        const newUrl = window.location.pathname;
        window.history.pushState(null, null, newUrl);
        showFormAreaAndHidePlayArea();
    };

    messageBox.appendChild(okButton);
    overlay.appendChild(messageBox);
    document.body.appendChild(overlay);
}